import styled from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';
import Iconmoon from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';

const FileItem = styled(Flex).attrs({
  align: 'center',
  justify: 'space-between',
})`
  margin: 24px 0 0;
  cursor: pointer;
  border: 1px solid ${color.downgray};
  box-sizing: border-box;
  border-radius: 6px;
  width: 100%;
  padding: 14px 16px;
`;

interface ExtensionBadgeProps {
  extension: 'DOC' | 'PDF' | 'XLS' | 'PPT';
}

const ExtensionBadge = styled.span<ExtensionBadgeProps>`
  padding: 0 4px;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
  max-height: 16px;

  background: ${({ extension }) => {
    switch (extension) {
      case 'DOC':
        return '#2479b4';
      case 'PDF':
        return '#ee4a49';
      case 'XLS':
        return '#00ab6b';
      default:
        return '#ffad01';
    }
  }};
`;

const IconCloseFile = styled(Iconmoon)`
  font-size: 12px;
  border-radius: 2px;
  margin-left: 5px;
  line-height: 12px;
  font-weight: 700;
  cursor: pointer;
`;

export { FileItem, ExtensionBadge, IconCloseFile };
